import React from "react";
import "./Csoon.scss";
import Comingsoon from "../../media/Bellefont_Desktop.webp";
import Soon from "../../media/Bellefont_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Promo,%20Brosur,%20dan Katalog%20produk%20terbaru%20Summarecon%20Serpong%20(Bellfont%20East)%20https://marketinggadingserpong.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="Bellefont" className="container-soon">
      <div className="louise">
        <h1>New Launching Summarecon Serpong</h1>
        <h2>Bellefont East</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-Desktop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
